var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-product-grade"},[_c('c-stars',{attrs:{"count":_vm.product.grade,"is-small":_vm.needSmall,"is-disabled":_vm.disableStars}}),_c('p',{class:{'small': _vm.needSmall, 'big': !_vm.needSmall}},[_c('span',[_vm._v(_vm._s(_vm.product.grade))]),_vm._v("/"),_c('span',[_vm._v(_vm._s(_vm.product.comCount))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }